module.exports = __webpack_public_path__ + "img/threePeopleBuyingHome.ba0b931d.jpeg";